<!-- src/App.vue -->
<script setup lang="ts">
import { type Component, computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from '@/layouts/DashboardLayout.vue'

const route = useRoute()

const layouts = {
  default: DefaultLayout,
  slim: defineAsyncComponent(() => import('@/layouts/DashboardSlim.vue')),
  login: defineAsyncComponent(() => import('@/layouts/Login.vue')),
} as const

type LayoutKey = keyof typeof layouts
const layout = computed<LayoutKey>(() => (route.meta.layout ?? 'default') as LayoutKey)
</script>

<template>
  <component :is="layouts[layout]">
    <RouterView />
  </component>
</template>
